import { IDatabaseColumn, IObj, ISelect } from '@common/types/';
import { find, get, isEmpty, isNil, map } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { getListOptions } from '@common/services';
import { simpleBindingSelector } from '@common/redux/selectors/page';
import { useSelector } from 'react-redux';

export type useDropdownProps = {
  showDropDown: boolean;
  value: any;
  list: any[];
  handleShowDropdown: () => void;
  handleHiddenDropdown: () => void;
  handleChangeValue: (value: any) => any;
};

const useDropdown = (attributes: ISelect) => {
  const { changeInput, valueInput, dependencies } = attributes;
  const defaultValueInPage = useSelector(simpleBindingSelector(attributes.id));
  const [listOption, setListOption] = useState([]);

  const getLabelField = get(attributes, 'database.options.labelField');
  const isMakeCustom = get(attributes, 'seperate.enabled', false);

  const fieldTable: any[] = [];

  const getFieldTable = find(
    fieldTable,
    (item) => item.databaseUuid === attributes.databaseUuid
  );

  const getFieldId: IDatabaseColumn | any = find(
    getFieldTable?.fields,
    (item) => item.fid === getLabelField
  );

  const [showDropDown, setShowDropDown] = useState(false);

  const handleShowDropdown = () => setShowDropDown(true);
  const handleHiddenDropdown = () => setShowDropDown(false);

  const optionDataOfDatabase = useMemo(() => {
    const defaultValue =
      get(attributes, 'attributes.defaultValue.text') ||
      get(attributes, 'database.options.labelField');

    return map(listOption, (value: any) => {
      return {
        value: value._id || value.id,
        label: value?.[defaultValue],
      };
    }).filter(
      (item: Record<string, any>) => !isNil(item.label) || !isEmpty(item.label)
    );
  }, [listOption, getFieldTable, getFieldId]);

  const optionCustomData = useMemo(() => {
    const items = get(attributes, 'seperate.items', '') || '';
    return items
      .split('\n')
      .map((item: string) => ({
        label: item.trim(),
        value: item.trim(),
      }))
      .filter(
        (item: Record<string, any>) =>
          !isNil(item.label) || !isEmpty(item.label)
      );
  }, [attributes]);

  const list = isMakeCustom ? optionCustomData : optionDataOfDatabase;

  const handleChangeValue = (value: any) => {
    changeInput(value);
  };

  // set default value dropdown
  useEffect(() => {
    if (!valueInput && isMakeCustom && defaultValueInPage?.defaultValue) {
      changeInput(defaultValueInPage?.defaultValue);
    } else if (
      !valueInput &&
      attributes.dataBinding?.length &&
      attributes.dataBinding[0]?.defaultValue
    ) {
      changeInput(attributes.dataBinding[0]?.defaultValue);
    }
  }, [attributes.id, attributes.dataBinding, defaultValueInPage]);

  useEffect(() => {
    const getListOption = async (field: IObj) => {
      const params = {
        appId: dependencies.appInfor.id,
        fieldId: field?.fieldId,
        screenUuid: attributes?.screenUuid,
        objectId: attributes?.formId,
        dependencies,
      };

      getListOptions(params)
        .then((resp) => {
          setListOption(resp.data);
        })
        .catch(() => {
          setListOption([]);
        });
    };

    if (attributes?.formId && attributes?.field && dependencies?.appInfor) {
      getListOption(attributes?.field);
    } else {
      setListOption(attributes.dataBinding || []);
    }
  }, [attributes]);

  return {
    showDropDown,
    value: valueInput,
    list,
    handleShowDropdown,
    handleHiddenDropdown,
    handleChangeValue,
  };
};

export default useDropdown;
